import React from 'react';
import { Button } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

// Barre d'actions fixe en bas de page : brouillon / signature, ou export PDF si déjà validé
export default function BottomActionBar({ classes, isLocked, disabled, signatureName, onSaveDraft, onValidate, onExportPDF }) {
    return (
        <div className={classes.bottomBar}>
            {isLocked ? (
                <Button variant="contained" color="secondary" disabled={disabled} startIcon={<PictureAsPdfIcon />} onClick={onExportPDF} style={{ borderRadius: 20, padding: '10px 24px' }}>
                    Télécharger PDF
                </Button>
            ) : (
                <>
                    <Button variant="outlined" color="primary" disabled={disabled} startIcon={<SaveIcon />} onClick={onSaveDraft} style={{ borderRadius: 20, padding: '10px 24px' }}>
                        Brouillon
                    </Button>
                    <Button variant="contained" color="primary" disabled={disabled || !signatureName} onClick={onValidate} startIcon={<CheckCircleIcon />} style={{ borderRadius: 20, padding: '10px 24px' }}>
                        Signer
                    </Button>
                </>
            )}
        </div>
    );
}
